<template>
    <v-dialog v-model="dialog" max-width="500" persistent>
      <v-card>
          <v-card-title class="primary white--text title">
              {{'Change Password'|translate}}
          </v-card-title>
          <v-card-text>
              <v-text-field :label="'User Name'|translate" disabled v-model="activeItem.user_name"></v-text-field>
              <v-text-field :label="'New Password'|translate" autofocus v-model="new_password" type="password"></v-text-field>
              <v-text-field :label="'Confirm New Password'|translate" v-model="check_password" type="password"></v-text-field>
               <span v-show="!password_matched">{{'Password not matched / Password cannot be empty'|translate}}</span>
          </v-card-text>

          <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn outline class="mr-2" @click="initializeVar(true)">{{'Cancel'|translate}}</v-btn>
              <v-btn class="primary mr-2 elevation-4" @click="addRecord()" :disabled="!password_matched">{{'Save'|translate}}</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>
</template>

<script>
  import {putUser} from '../../helper'
  import {sameAs} from 'vuelidate/lib/validators'


  import Vue from 'vue'
  import SimpleVueValidation from 'simple-vue-validator'
  const Validator = SimpleVueValidation.Validator
  Vue.use(SimpleVueValidation)


  export default {
    components: { },
    props: {
      value: {type:Boolean, default: true},
      item: {type: Object, default: null}
    },
    watch: {
      item (item) {
        this.initializeVar()
        if (item){
          this.activeItem = this.item
        }
      },
      value () {
        if (!this.activeItem.user_id) {
          this.initializeVar()
        }
        if (this.dialog !=this.value){
          this.dialog=this.value
          this.activeItem=this.item
        }
      },
      dialog () {
        this.$emit('input', this.dialog)
      }
    },
    computed: {
      password_matched () {
        if (this.new_password==''){
          return false
        }
        return this.new_password==this.check_password
      }
    },
    mounted () {
      this.dialog = this.value
    },
    data () {
      return {
        dialog: false,
        activeItem: {
          user_name: '',


        } ,
        new_password:  '',
        check_password: '',
      }
    },

    validators: {
      password: function (value) {
        return Validator.value(value).required().minLength(6);
      },
      'repeat, password': function (repeat, password) {
        if (this.submitted || this.validation.isTouched('repeat')) {
          return Validator.value(repeat).required().match(password);
        }
      }
    },

    methods: {

      submit: function (){
        this.submitted =true;
        this.$validate()
          .then(function(success){
            if (success){
              alert(this.$options.filters.translate('Validation succeeded!'))
            }
          })
      },

      initializeVar(close) {
        this.activeItem = {
          user_name:  '',
          new_password: '',
          check_password: ''
          }
          if(close) {
              this.dialog = false;
          }
      },
      addRecord () {
        putUser(
          {
            'user_id': this.activeItem.user_id,
            'email': this.activeItem.email,
            'user_name': this.activeItem.user_name,
            'updated_on': this.activeItem.updated_on,
            'created_on': this.activeItem.created_on,
            'role': this.activeItem.role,
            'password': this.new_password,
          }
        )
        this.dialog=false
      }
    },

    validations: {
      check_password:{
        sameAsPassword: sameAs('new_password')
      }
    },
    name: 'ChangePasswordDialog'
  }



</script>

<style scoped>

</style>

